(function () {
  if (!window.location.pathname.endsWith('/collections/decals')) {
    return;
  }

  const grid = document.getElementById('product-grid');
  if (!grid) {
    return;
  }

  function getGridItems() {
    const currentGrid = document.getElementById('product-grid');
    if (!currentGrid) {
      return [];
    }

    return [...currentGrid.querySelectorAll('.grid__item[data-ovs-decal-product]')];
  }

  function passesAvailability(item) {
    return window.OvsTsFilterUtils ? window.OvsTsFilterUtils.itemPassesAvailability(item) : true;
  }

  const pagination = document.querySelector('.pagination-wrapper');

  function parseList(param) {
    const raw = new URLSearchParams(window.location.search).get(param);
    if (!raw) {
      return [];
    }

    return raw
      .split(',')
      .map((value) => value.trim())
      .filter((value) => value !== '');
  }

  function selectedProducts() {
    const products = new Set();
    document.querySelectorAll('.ovs-decal-product-input:checked').forEach((input) => {
      const product = input.dataset.ovsDecalProduct || '';
      if (product !== '') {
        products.add(product);
      }
    });

    return [...products];
  }

  function selectedBrands() {
    const brands = new Set();
    document.querySelectorAll('.ovs-decal-brand-input:checked').forEach((input) => {
      const brand = input.dataset.ovsDecalBrand || '';
      if (brand !== '') {
        brands.add(brand);
      }
    });

    return [...brands];
  }

  function syncCheckboxLabels() {
    document.querySelectorAll('.ovs-decal-product-input').forEach((input) => {
      const label = input.closest('.ovs-decal-product-option');
      if (label) {
        label.classList.toggle('active', input.checked);
      }
    });

    document.querySelectorAll('.ovs-decal-brand-input').forEach((input) => {
      const label = input.closest('.ovs-decal-brand-option');
      if (label) {
        label.classList.toggle('active', input.checked);
      }
    });
  }

  function syncCheckboxesFromUrl() {
    const products = parseList('ovs_decal_product');
    const brands = parseList('ovs_decal_brand');

    document.querySelectorAll('.ovs-decal-product-input').forEach((input) => {
      const product = input.dataset.ovsDecalProduct || '';
      input.checked = products.includes(product);
    });

    document.querySelectorAll('.ovs-decal-brand-input').forEach((input) => {
      const brand = input.dataset.ovsDecalBrand || '';
      input.checked = brands.includes(brand);
    });

    syncCheckboxLabels();
  }

  function buildUrl(products, brands) {
    const url = new URL(window.location.href);
    url.searchParams.delete('ovs_decal_product');
    url.searchParams.delete('ovs_decal_brand');
    url.searchParams.delete('page');

    if (products.length > 0) {
      url.searchParams.set('ovs_decal_product', products.join(','));
    }

    if (brands.length > 0) {
      url.searchParams.set('ovs_decal_brand', brands.join(','));
    }

    return url;
  }

  function updateProductCount(visibleCount) {
    const countNodes = document.querySelectorAll(
      '#ProductCountDesktop, #ProductCountMobile, .product-count__text span',
    );
    countNodes.forEach((node) => {
      if (visibleCount === 1) {
        node.textContent = '1 product';
      } else {
        node.textContent = visibleCount + ' products';
      }
    });
  }

  function togglePagination(products, brands) {
    if (!pagination) {
      return;
    }

    pagination.hidden = products.length > 0 || brands.length > 0;
  }

  function applyFilters(updateHistory) {
    const products = selectedProducts();
    const brands = selectedBrands();
    let visibleCount = 0;

    getGridItems().forEach((item) => {
      const itemProduct = item.dataset.ovsDecalProduct || '';
      const itemBrand = item.dataset.ovsDecalBrand || '';
      let show = true;

      if (products.length > 0) {
        show = itemProduct !== '' && products.includes(itemProduct);
      }

      if (show && brands.length > 0) {
        show = itemBrand !== '' && brands.includes(itemBrand);
      }

      if (show) {
        show = passesAvailability(item);
      }

      item.hidden = !show;
      if (show) {
        visibleCount += 1;
      }
    });

    syncCheckboxLabels();
    updateProductCount(visibleCount);
    togglePagination(products, brands);

    if (updateHistory) {
      const url = buildUrl(products, brands);
      window.history.pushState({ ovsDecalFilters: true }, '', url.pathname + url.search);
    }
  }

  document.querySelectorAll('.ovs-decal-product-input, .ovs-decal-brand-input').forEach((input) => {
    input.addEventListener('change', () => {
      applyFilters(true);
    });
  });

  window.addEventListener('popstate', () => {
    syncCheckboxesFromUrl();
    applyFilters(false);
  });

  syncCheckboxesFromUrl();
  applyFilters(false);

  function reapplyFilters() {
    syncCheckboxesFromUrl();
    applyFilters(false);
    if (typeof window.ovsSortToolsSuppliesBySku === 'function') {
      window.ovsSortToolsSuppliesBySku();
    }
  }

  if (window.OvsTsFilterUtils) {
    window.OvsTsFilterUtils.onGridUpdated(reapplyFilters);
    window.OvsTsFilterUtils.onAvailabilityChanged(() => applyFilters(false));
  }
})();
